import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useSetAtom } from 'jotai';
import { PERMISSION_NEW_RIDE } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';
import NewRideForm from '../../components/TripsOverviewNew/NewRide/Form';
import { updateTableTrigger } from '../../components/TripsOverviewNew/TripsOverviewState';
import { URL_TRIPS_OVERVIEW } from '../../router/constants';

export const Route = createFileRoute('/_authenticated/overview_tours/edit/$vehicleId/$rideId')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_NEW_RIDE, ['update'], '/unauthorized', context);
    return {
      ...context,
      documentTitle: {
        main: 'menu.rideBook',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: EditRideRoute,
});

function EditRideRoute() {
  const { vehicleId, rideId } = Route.useParams();
  const navigate = useNavigate();
  const setUpdateTableTrigger = useSetAtom(updateTableTrigger);

  return (
    <NewRideForm
      handleClose={() => navigate({ to: URL_TRIPS_OVERVIEW })}
      updateTable={() => setUpdateTableTrigger(true)}
      rideId={rideId}
      vehicleId={vehicleId}
    />
  );
}
